import { useCreateTimeEntryMutation } from "generated/graphql";
import getLocalString from "constants/Localization";
import useBitumioMutation from "hooks/useBitumioMutation";

export const useCreateTimeEntry = () => {
  const [mutation, { loading, error, data }] = useCreateTimeEntryMutation({
    update: (cache) => {
      // Also invalidate skipped views so switching tabs cannot reuse stale results.
      cache.evict({ id: "ROOT_QUERY", fieldName: "getTimeEntries" });
      cache.evict({ id: "ROOT_QUERY", fieldName: "getTimeEntriesGroupedByUser" });
    },
    awaitRefetchQueries: true,
    refetchQueries: ["customGetTimeEntries", "getTimeEntries", "getTimeEntriesGroupedByUser"],
    fetchPolicy: "network-only",
  });

  const [createTimeEntry, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createTimeEntry",
    },
    {
      successMessage: getLocalString("time-tracking.create-time-entry-success"),
      failureMessage: getLocalString("time-tracking.create-time-entry-failure"),
      showValidationErrors: true,
    }
  );

  return [createTimeEntry, context] as const;
};
